import React from "react";

export const MapIcon: React.FC = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3431_7187)">
      <path
        d="M1.625 10.5H22.625M21.125 16.5V18.75C21.125 18.9489 21.046 19.1397 20.9053 19.2803C20.7647 19.421 20.5739 19.5 20.375 19.5H18.125C17.9261 19.5 17.7353 19.421 17.5947 19.2803C17.454 19.1397 17.375 18.9489 17.375 18.75V16.5M21.125 16.5H3.125M21.125 16.5V10.5L18.3406 5.625C18.2747 5.51082 18.1799 5.41604 18.0656 5.3502C17.9514 5.28437 17.8218 5.24981 17.69 5.25H6.56C6.42816 5.24981 6.2986 5.28437 6.18437 5.3502C6.07015 5.41604 5.97529 5.51082 5.90938 5.625L3.125 10.5V16.5M6.875 16.5V18.75C6.875 18.9489 6.79598 19.1397 6.65533 19.2803C6.51468 19.421 6.32391 19.5 6.125 19.5H3.875C3.67609 19.5 3.48532 19.421 3.34467 19.2803C3.20402 19.1397 3.125 18.9489 3.125 18.75V16.5M6.125 13.5H7.625M16.625 13.5H18.125M9.875 2.25H14.375"
        stroke="#8C8A92"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3431_7187">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EventsIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill="currentColor"
    />
  </svg>
);

export const WebcamsIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_656_8184)">
      <path
        d="M23.2492 13.5V18M17.2492 3.4397L4.9389 15.75M4.9389 15.75H0.936713C0.899744 15.7499 0.863645 15.7388 0.832956 15.7182C0.802266 15.6975 0.778355 15.6683 0.764228 15.6342C0.750102 15.6 0.74639 15.5624 0.75356 15.5261C0.76073 15.4899 0.778461 15.4565 0.804525 15.4303L14.4686 1.71939C14.5382 1.64965 14.621 1.59433 14.712 1.55659C14.8031 1.51885 14.9007 1.49942 14.9992 1.49942C15.0978 1.49942 15.1954 1.51885 15.2864 1.55659C15.3775 1.59433 15.4602 1.64965 15.5298 1.71939L20.7798 6.96938C20.8496 7.03904 20.9049 7.12176 20.9426 7.21281C20.9804 7.30385 20.9998 7.40145 20.9998 7.50001C20.9998 7.59857 20.9804 7.69617 20.9426 7.78722C20.9049 7.87826 20.8496 7.96098 20.7798 8.03064L9.52984 19.2806C9.46018 19.3504 9.37747 19.4057 9.28642 19.4434C9.19537 19.4812 9.09777 19.5006 8.99921 19.5006C8.90065 19.5006 8.80306 19.4812 8.71201 19.4434C8.62096 19.4057 8.53824 19.3504 8.46859 19.2806L4.9389 15.75ZM15.5298 13.2806L17.7798 15.5306C17.9204 15.671 18.1109 15.7499 18.3095 15.75H23.2492"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_656_8184">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SettingsIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      fill="currentColor"
    />
  </svg>
);

export const ContestIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1608_19295)">
      <path
        d="M9 21H15"
        stroke="#8C8A92"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 17.25V21"
        stroke="#8C8A92"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.4375 12H4.5C3.70435 12 2.94129 11.6839 2.37868 11.1213C1.81607 10.5587 1.5 9.79565 1.5 9V7.5C1.5 7.30109 1.57902 7.11032 1.71967 6.96967C1.86032 6.82902 2.05109 6.75 2.25 6.75H5.25"
        stroke="#8C8A92"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5625 12H19.5C20.2956 12 21.0587 11.6839 21.6213 11.1213C22.1839 10.5587 22.5 9.79565 22.5 9V7.5C22.5 7.30109 22.421 7.11032 22.2803 6.96967C22.1397 6.82902 21.9489 6.75 21.75 6.75H18.75"
        stroke="#8C8A92"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 4.5H18.75V10.4156C18.75 14.1375 15.7734 17.2219 12.0516 17.25C11.1608 17.2568 10.2775 17.0872 9.45261 16.7511C8.6277 16.4149 7.87749 15.9188 7.24522 15.2913C6.61296 14.6638 6.11114 13.9174 5.7687 13.0951C5.42626 12.2728 5.24997 11.3908 5.25 10.5V4.5Z"
        stroke="#8C8A92"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1608_19295">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FlowersIcon = () => (
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none">
    <path
      d="M8.875 20.75V15.5M8.875 20.75L4.375 18.5M8.875 20.75L13.375 18.5M8.875 15.5V11.75M8.875 15.5C6.88588 15.5 4.97822 14.7098 3.5717 13.3033C2.16518 11.8968 1.375 9.98912 1.375 8V4.25C3.36412 4.25 5.27178 5.04018 6.6783 6.4467C8.08482 7.85322 8.875 9.76088 8.875 11.75M8.875 15.5C10.8641 15.5 12.7718 14.7098 14.1783 13.3033C15.5848 11.8968 16.375 9.98912 16.375 8V4.25C14.3859 4.25 12.4782 5.04018 11.0717 6.4467C9.66518 7.85322 8.875 9.76088 8.875 11.75M5.00969 5.1875C6.25 2.5625 8.875 1.25 8.875 1.25C8.875 1.25 11.5 2.5625 12.7403 5.1875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NetworkingIcon: React.FC = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2729 14.2497C15.8776 14.9335 15.3093 15.5013 14.6251 15.896C13.9409 16.2908 13.1649 16.4986 12.375 16.4986C11.5851 16.4986 10.8091 16.2908 10.1249 15.8961C9.44074 15.5013 8.87243 14.9335 8.47705 14.2497M21.375 12C21.375 16.9706 17.3456 21 12.375 21C7.40444 21 3.375 16.9706 3.375 12C3.375 7.02944 7.40444 3 12.375 3C17.3456 3 21.375 7.02944 21.375 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.25C9.62132 11.25 10.125 10.7463 10.125 10.125C10.125 9.50368 9.62132 9 9 9C8.37868 9 7.875 9.50368 7.875 10.125C7.875 10.7463 8.37868 11.25 9 11.25Z"
      fill="currentColor"
    />
    <path
      d="M15.75 11.25C16.3713 11.25 16.875 10.7463 16.875 10.125C16.875 9.50368 16.3713 9 15.75 9C15.1287 9 14.625 9.50368 14.625 10.125C14.625 10.7463 15.1287 11.25 15.75 11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7.5H21V10.5H3V7.5H12ZM12 7.5C12 5.84315 10.6569 4.5 9 4.5C7.34315 4.5 6 5.84315 6 7.5C6 9.15685 7.34315 10.5 9 10.5H12M12 7.5C12 5.84315 13.3431 4.5 15 4.5C16.6569 4.5 18 5.84315 18 7.5C18 9.15685 16.6569 10.5 15 10.5H12M12 7.5V21M4.5 10.5V19.5C4.5 20.0967 4.73705 20.669 5.15901 21.091C5.58097 21.5129 6.15326 21.75 6.75 21.75H17.25C17.8467 21.75 18.419 21.5129 18.841 21.091C19.2629 20.669 19.5 20.0967 19.5 19.5V10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
